import React from 'react';

// Make group for face '.fill--face'
// Make glasses target 'ref="glassesTarget"'
// Make groups for each eye group
// - '.fill-eyes eyes'
// - '.fill-face eyes--blink'
// - '.fill-face eyes--is-being-pet--likes'
// - '.fill-eyes eyes--is-being-pet--hates'

export default class Eyes extends React.Component {
	componentDidMount() {
		this.props.getGlassesTargetCoords(this.refs.glassesTarget);
	}
	render() {
		return (
			<g className="fill--face">
				<circle ref="glassesTarget"cx="238.22212" cy="193.70601" r="0" />
				<g className="fill--eyes eyes">
					<ellipse cx="221.2341" cy="193.70601" rx="5.77192" ry="6.25846" />
					<ellipse cx="255.21025" cy="193.70601" rx="5.77192" ry="6.25846" />
				</g>
				<g className="fill--face eyes--blink">
					<path d="M249.35239,197.01091c-0.86926-0.06667-1.59607-0.74304-1.69537-1.64136c-0.11276-1.01572,0.61937-1.93073,1.63507-2.0435
						l11.43094-1.26855c1.01566-0.11206,1.93109,0.61938,2.04309,1.63541c0.11279,1.0157-0.61935,1.93073-1.63507,2.04349
						l-11.43091,1.26857C249.5824,197.01804,249.46628,197.01965,249.35239,197.01091z" />
					<path d="M227.09703,197.00969c0.86963-0.06671,1.59674-0.74336,1.69608-1.64204c0.11282-1.01613-0.61961-1.93153-1.63574-2.04436
						l-11.43568-1.26909c-1.01607-0.11209-1.93188,0.61966-2.04396,1.63609c-0.11281,1.01613,0.61963,1.93153,1.63576,2.04434
						l11.43567,1.2691C226.86693,197.01682,226.98311,197.01843,227.09703,197.00969z" />
				</g>
				<g className="fill--face eyes--is-being-pet--likes">
					<path d="M215.68059,197.02895c-0.50008-0.0192-0.99028-0.23956-1.33998-0.65068c-0.66273-0.77884-0.56795-1.9473,0.21088-2.60965
						c1.56964-1.33513,3.98746-2.12241,6.63342-2.15981c2.64819-0.03877,5.08557,0.68225,6.69193,1.97353
						c0.79684,0.64069,0.92365,1.80606,0.28296,2.60292c-0.64143,0.79718-1.8064,0.92255-2.60258,0.28333
						c-0.7196-0.57874-2.22496-1.18294-4.32043-1.15732c-2.08693,0.02954-3.58252,0.6796-4.28651,1.27789
						C216.58217,196.90216,216.12793,197.04611,215.68059,197.02895z" />
					<path d="M260.76324,197.02895c0.50009-0.0192,0.9903-0.23956,1.34-0.65068c0.66272-0.77884,0.56796-1.9473-0.21088-2.60965
						c-1.56964-1.33513-3.98746-2.12241-6.63342-2.15981c-2.64819-0.03877-5.08557,0.68225-6.69193,1.97353
						c-0.79684,0.64069-0.92365,1.80606-0.28296,2.60292c0.64143,0.79718,1.8064,0.92255,2.60258,0.28333
						c0.7196-0.57874,2.22496-1.18294,4.32043-1.15732c2.08693,0.02954,3.5825,0.6796,4.28651,1.27789
						C259.86169,196.90216,260.31592,197.04611,260.76324,197.02895z" />
				</g>
				<g className="fill--eyes eyes--is-being-pet--hates">
					<path d="M260.98193,193.70601c0,3.91667-2.5842,6.25845-5.77193,6.25845c-3.18774,0-5.77193-2.34178-5.77193-6.25845
						c0-2.40128,2.58418-2.40128,5.77193-2.40128C258.39774,191.30473,260.98193,191.30473,260.98193,193.70601z" />
					<path d="M227.00577,193.70601c0,3.91667-2.58418,6.25845-5.77193,6.25845s-5.77191-2.34178-5.77191-6.25845
						c0-2.40128,2.58417-2.40128,5.77191-2.40128S227.00577,191.30473,227.00577,193.70601z" />
				</g>
			</g>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Global/Pet/Chicken/Eyes.js